import { AlignCenterOutlined, LineChartOutlined } from "@ant-design/icons";
import { Tabs } from "antd";
import React from "react";
// import TLogLiveGraph from "./TlogGraph";
import { useSelector } from "react-redux";
import TlogGraphView from "./tlog_graph_view";
import TlogTableView from "./tlog_table_view";

const TlogTab = ({
  setActiveTab,
  station_number,
  s_deviceid_event,
  view,
  torch,
  zone,
  tilt_start,
  tilt_end,
  rawZone,
}) => {
  const currentProject = useSelector(
    (state) => state?.data360LiveProjectReducer?.currentProject
  );
  const tabKeys = {
    TableView: "TableView",
    GraphView: "GraphView",
  };

  const tabItems = [
    {
      key: tabKeys.TableView,
      label: (
        <>
          <AlignCenterOutlined />
          Table View
        </>
      ),
      children: (
        <TlogTableView
          s_deviceid_event={s_deviceid_event}
          station_number={station_number}
          view={view}
          torch={torch}
          zone={zone}
          tilt_start={tilt_start}
          tilt_end={tilt_end}
          rawZone={rawZone}
          statusCalculationMethod={currentProject?.statusCalculationMethod}
        />
      ),
    },
    {
      key: tabKeys.GraphView,
      label: (
        <>
          <LineChartOutlined />
          Graph View
        </>
      ),
      children: (
        <TlogGraphView
          s_deviceid_event={s_deviceid_event}
          view={view}
          torch={torch}
          zone={zone}
          tilt_start={tilt_start}
          tilt_end={tilt_end}
          rawZone={rawZone}
        />
      ),
    },
  ];

  return (
    <Tabs
      defaultActiveKey={tabKeys.TableView}
      items={tabItems}
      className="custom-tab"
      destroyInactiveTabPane={true}
      onChange={(key) => setActiveTab(key)}
    />
  );
};

export default TlogTab;
